import React from 'react'
import logo from "../../Assets/logoWhite.png"

import style from './style.module.scss';
import { MDBBtn } from 'mdb-react-ui-kit';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div className={style.mainContainer}>
        <div className={style.notFound}>
            <div className={style.logo}>
                <div className={style.image}>
                    <img src={logo} alt='logo' />
                </div>
            </div>
            <div className={style.notif}>
                <h4 className={style.text}>Ops! You seems lost..</h4>
                <div className={style.btnContainer}>
                    <Link to={'/login'}>
                        <MDBBtn className={style.btn}>
                            Sign in
                        </MDBBtn>
                    </Link>
                </div>
            </div>
        </div>
    </div>
  )
}

export default NotFound